//const BASE_URL = 'http://localhost:3000'

const getURL = () =>{
  if (process.env.REACT_APP_DEBUG==='1'){
    return process.env.REACT_APP_MINHA_URL
}else{
    return `https://${window.location.hostname}`
}
}

const backEnd = {
  url: `${getURL()}/api/`,
  base_url: `${getURL()}`,
};

export default backEnd;
